import { newrelic } from "@jti/fe-clients";

type PickupInformation = {
  id: string;
  name: string;
};

export const fromMagentoPickupInformation = (pickupInformation: string | undefined): PickupInformation | undefined => {
  if (!pickupInformation) {
    return undefined;
  }

  try {
    const { store_id, store_name } = JSON.parse(pickupInformation);

    return {
      id: store_id,
      name: store_name,
    };
  } catch (error: unknown) {
    if (error instanceof Error) {
      newrelic.noticeError(error);
    }

    console.error(error);

    return undefined;
  }
};
